// NOTE: hooks
import { useQuery } from '@tanstack/react-query'
import { useAuthContext } from './useAuthContext'
import { getFileUrl } from '../api/health/firebase'
import loadImage from '../utils/loadImage'

const IMAGE_EXTENSIONS = /\.(png|jpe?g|gif|webp|avif|svg|bmp)$/i

const useFirebaseFile = (path: string | null | undefined) => {
	const { user } = useAuthContext()

	const { isLoading: isLoadingFileUrl, isError: isErrorFileUrl, error: errorFileUrl, data: fileUrl } = useQuery({
		queryKey: ['firebaseFile', path],
		queryFn: async () => {
			const response = await getFileUrl(path as string, user.token)

			const json = await response.json()

			if (!response.ok) throw new Error(json.error)

			if (path && IMAGE_EXTENSIONS.test(path)) await loadImage({ url: json.url })

			return json.url as string
		},
		enabled: !!path && !!user?.token
	})

	return {
		isLoadingFileUrl,
		isErrorFileUrl,
		errorFileUrl,
		fileUrl
	}
}

export default useFirebaseFile
